// Application-Centre lifecycle copy (EN/FR). Maps backend `status_state` codes
// to prominent, actionable next-step messaging. French uses vouvoiement.

const STATES = {
  in_progress: {
    en: { title: "Application in progress", sub: "Pick up where you left off and complete your application.", cta: "Continue application" },
    fr: { title: "Candidature en cours", sub: "Reprenez là où vous vous êtes arrêté et complétez votre candidature.", cta: "Continuer la candidature" },
    tone: "brand",
  },
  assessment_payment: {
    en: { title: "Assessment required", sub: "Activate your application (€97) to unlock the mandatory admissions assessment.", cta: "Activate & start" },
    fr: { title: "Évaluation requise", sub: "Activez votre candidature (97 €) pour débloquer l'évaluation d'admission obligatoire.", cta: "Activer et commencer" },
    tone: "brand",
  },
  assessment_required: {
    en: { title: "Assessment required", sub: "The admissions assessment is mandatory. Complete it to continue.", cta: "Start assessment" },
    fr: { title: "Évaluation requise", sub: "L'évaluation d'admission est obligatoire. Passez-la pour continuer.", cta: "Commencer l'évaluation" },
    tone: "brand",
  },
  assessment_in_progress: {
    en: { title: "Assessment in progress", sub: "Resume your assessment — your progress is always saved.", cta: "Continue assessment" },
    fr: { title: "Évaluation en cours", sub: "Reprenez votre évaluation — votre progression est toujours enregistrée.", cta: "Continuer l'évaluation" },
    tone: "brand",
  },
  ready_to_submit: {
    en: { title: "Ready to submit", sub: "Your assessment is complete. Review and submit your application for academic review.", cta: "Review & submit" },
    fr: { title: "Prêt à soumettre", sub: "Votre évaluation est terminée. Vérifiez et soumettez votre candidature à l'examen académique.", cta: "Vérifier et soumettre" },
    tone: "green",
  },
  under_review: {
    en: { title: "Under review", sub: "Your application has been submitted and is under academic review. No action is required.", cta: null },
    fr: { title: "En cours d'examen", sub: "Votre candidature a été soumise et est en cours d'examen académique. Aucune action n'est requise.", cta: null },
    tone: "neutral",
  },
  interview: {
    en: { title: "Interview step", sub: "An admissions interview is part of your next step. Please check the details below.", cta: "View details" },
    fr: { title: "Étape d'entretien", sub: "Un entretien d'admission fait partie de votre prochaine étape. Consultez les détails ci-dessous.", cta: "Voir les détails" },
    tone: "brand",
  },
  decision: {
    en: { title: "There is an update to your application", sub: "An admissions decision is now available. Open it to see the outcome and next steps.", cta: "View decision" },
    fr: { title: "Mise à jour de votre candidature", sub: "Une décision d'admission est disponible. Ouvrez-la pour découvrir le résultat et les prochaines étapes.", cta: "Consulter la décision" },
    tone: "green",
  },
  enrolled: {
    en: { title: "Enrolled", sub: "Welcome to Simo University. Your student environment is now available.", cta: null },
    fr: { title: "Inscrit", sub: "Bienvenue à Simo University. Votre espace étudiant est désormais disponible.", cta: null },
    tone: "green",
  },
};

const CHECKLIST = {
  account: { en: "Application Centre account", fr: "Compte Espace candidature" },
  application_info: { en: "Application information", fr: "Informations de candidature" },
  assessment: { en: "Mandatory assessment", fr: "Évaluation obligatoire" },
  submitted: { en: "Review & submit", fr: "Vérifier et soumettre" },
};

export function centreCopy(state, lang = "en") {
  const s = STATES[state] || STATES.in_progress;
  const c = s[lang] || s.en;
  return { ...c, tone: s.tone };
}

export function checklistLabel(key, lang = "en") {
  const c = CHECKLIST[key];
  return c ? c[lang] || c.en : key;
}

export const TONES = {
  brand: "border-heraldic bg-heraldic/[0.06]",
  green: "border-green-600 bg-green-50",
  neutral: "border-ink/20 bg-ink/[0.03]",
};
